export default __webpack_public_path__ + "5e6695467f96bb24fe8575116b506342.png";